/* assets/section-wedding-service.js */

/* Gallery slider (per section instance) */
// (function () {
//   function initGallery(sectionEl) {
//     const track = sectionEl.querySelector("[data-wed-gallery-track]");
//     const prev = sectionEl.querySelector("[data-wed-gallery-prev]");
//     const next = sectionEl.querySelector("[data-wed-gallery-next]");
//     if (!track || !prev || !next) return;

//     const items = track.querySelectorAll("[data-wed-gallery-item]");
//     if (!items.length) return;

//     let index = 0;

//     function update() {
//       const viewport = sectionEl.querySelector("[data-wed-gallery-viewport]");
//       const vw = viewport ? viewport.clientWidth : items[0].clientWidth;
//       // each item is 100% viewport width
//       track.style.transform = `translateX(-${index * vw}px)`;
//     }

//     prev.addEventListener("click", function () {
//       index = (index - 1 + items.length) % items.length;
//       update();
//     });

//     next.addEventListener("click", function () {
//       index = (index + 1) % items.length;
//       update();
//     });

//     window.addEventListener("resize", update);
//     update();
//   }

//   document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll("[data-wed-gallery]").forEach(initGallery);
//   });

//   /* Shopify theme editor support */
//   document.addEventListener("shopify:section:load", function (e) {
//     if (!e.target) return;
//     e.target.querySelectorAll("[data-wed-gallery]").forEach(initGallery);
//   });
// })();

/* assets/section-wedding-service.js */
(function () {
  function isMobile() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function init(sectionEl) {
    const prev = sectionEl.querySelector("[data-wed-gallery-prev]");
    const next = sectionEl.querySelector("[data-wed-gallery-next]");
    const viewport = sectionEl.querySelector("[data-wed-gallery-viewport]");
    if (!prev || !next || !viewport) return;

    let index = 0;
    let lastMode = isMobile() ? "mobile" : "desktop";

    function getTrack(mode) {
      return sectionEl.querySelector(
        `[data-wed-gallery-track][data-track="${mode}"]`
      );
    }

    function getCount(mode, track) {
      if (!track) return 0;
      return mode === "desktop"
        ? track.querySelectorAll("[data-wed-gallery-slide]").length
        : track.querySelectorAll("[data-wed-gallery-item]").length;
    }

    function getStep(mode, track) {
      if (!track) return 0;

      if (mode === "desktop") {
        return viewport.getBoundingClientRect().width;
      }

      const item = track.querySelector("[data-wed-gallery-item]");
      if (!item) return 0;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.gap || styles.columnGap || "24") || 24;
      return item.getBoundingClientRect().width + gap;
    }

    function setDisabled(count) {
      const atStart = index <= 0;
      const atEnd = index >= count - 1;

      prev.disabled = atStart;
      next.disabled = atEnd;

      prev.setAttribute("aria-disabled", atStart ? "true" : "false");
      next.setAttribute("aria-disabled", atEnd ? "true" : "false");
    }

    function update() {
      const mode = isMobile() ? "mobile" : "desktop";
      const track = getTrack(mode);
      if (!track) return;

      // reset when switching modes
      if (mode !== lastMode) {
        index = 0;
        const other = getTrack(mode === "mobile" ? "desktop" : "mobile");
        if (other) other.style.transform = "translate3d(0,0,0)";
        lastMode = mode;
      }

      const count = getCount(mode, track);
      if (count <= 0) return;

      // clamp
      if (index > count - 1) index = count - 1;
      if (index < 0) index = 0;

      const step = getStep(mode, track);
      track.style.transform = `translate3d(-${index * step}px,0,0)`;

      // ✅ disable arrows at edges (no looping)
      setDisabled(count);
    }

    prev.addEventListener("click", function () {
      const mode = isMobile() ? "mobile" : "desktop";
      const track = getTrack(mode);
      const count = getCount(mode, track);
      if (count <= 0) return;

      if (index <= 0) return; // ✅ no wrap
      index -= 1;
      update();
    });

    next.addEventListener("click", function () {
      const mode = isMobile() ? "mobile" : "desktop";
      const track = getTrack(mode);
      const count = getCount(mode, track);
      if (count <= 0) return;

      if (index >= count - 1) return; // ✅ no wrap
      index += 1;
      update();
    });

    window.addEventListener("resize", update);
    update();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-wed-gallery]").forEach(init);
  });

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target) return;
    e.target.querySelectorAll("[data-wed-gallery]").forEach(init);
  });
})();